// extracted by mini-css-extract-plugin
export default {"menuBar":"menu-bar_menuBar__ULsbH"};